<div class="img-box" draggable="false"  [ngClass]="{'badges-on-cell': allowDelete }">
  <div class="splinerBox" *ngIf="isLoading">
    <div class="spliner"></div>
  </div>
  <div *ngIf="!isGalleryManager" class="remove-badge" (click)="delete(media)">
    <i id="remove-element" class="material-icons" home365Link *ngIf="!isLoading && allowDelete">cancel</i>
    <div id="remove-element-background" *ngIf="!isLoading && allowDelete"></div>
  </div>

  <div class="inside-badges" *ngIf="!isLoading && !isGalleryManager">
    <div *ngIf="canShowFavourite" class="primary">
      <i *ngIf="!media.isPrimary" matTooltip="{{'GENERAL.SET_PRIMARY_PHOTO' | translate}}" matTooltipClass="tooltip" id="set-star" (click)="favouritesClicked('set-primary')" class="material-icons pointer rounded-background">star_outline</i>
      <i *ngIf="media.isPrimary" matTooltip="{{'GENERAL.PRIMARY_PHOTO' | translate}}" matTooltipClass="tooltip" id="stared" (click)="favouritesClicked('remove-primary')"  class="material-icons pointer rounded-background">star</i>
    </div>
  </div>
<!--  <i class="material-icons">star_outline</i>-->
<!--  <i class="material-icons">star</i>-->

  <ng-container *ngIf="media.src" [ngSwitch]="media.type">
    <ng-container *ngSwitchCase="'video'">
      <lib-video-wrapper [video]="media" [objectFit]="objectFit" (isLoadingEmitter)="setLoading($event)"></lib-video-wrapper>
    </ng-container>
    <ng-container *ngSwitchCase="'pdf'">
      <lib-pdf-wrapper  [pdf]="media" [objectFit]="objectFit" (isLoadingEmitter)="setLoading($event)"></lib-pdf-wrapper>
    </ng-container>
    <ng-container *ngSwitchCase="'image'">
      <lib-img-wrapper [image]="media" [objectFit]="objectFit" [borderRadius]="borderRadius" (isLoadingEmitter)="setLoading($event)"></lib-img-wrapper>
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
      <lib-other-wrapper [file]="media" [objectFit]="objectFit" [isGalleryManager]="isGalleryManager" (isLoadingEmitter)="setLoading($event)"></lib-other-wrapper>
    </ng-container>
  </ng-container>
</div>


















<!--<img *ngIf="media.thumbnail && media.type === 'video'" id="play-icon" src="assets/icons/play_icon.svg" alt=""/>-->
<!--<div class="splinerBox" *ngIf="!media.thumbnail && (media.type === 'video' ||  media.type === 'pdf')">-->
<!--  <div class="spliner"></div>-->
<!--</div>-->
<!--<img *ngIf="!media.thumbnail && media.type === 'pdf'" src="assets/img/pdfPlaceholder.png" [style.object-fit]="objectFit">-->
<!--<img *ngIf="!media.thumbnail && media.type === 'video' " src="assets/img/videoPlaceholder.png" [style.object-fit]="objectFit">-->
<!-- Image -->
<!--<div class="img-box" draggable="false" [style.height]="allowDelete ? '90%' : '100%'">-->
<!--  <ng-container *ngIf="media.src" [ngSwitch]="media.type">-->
<!--    <ng-container *ngSwitchCase="'video'">-->
<!--      <section class="video-wrapper">-->
<!--        <ng-container *ngIf="!media.type">-->
<!--          <vg-player class="flex-1">-->
<!--            <video-->
<!--              #vid [vgMedia]="$any(media)"-->
<!--              (canplay)="media.thumbnail = media.src"-->
<!--              [vgHls]="media.src"-->
<!--              id="singleVideo1"-->
<!--            ></video>-->
<!--          </vg-player>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="media.thumbnail">-->
<!--          <vg-player class="flex-1">-->
<!--            <video-->
<!--              #media [vgMedia]="$any(media)"-->
<!--              [vgHls]="media.src"-->
<!--              id="singleVideo2"-->
<!--            ></video>-->
<!--          </vg-player>-->
<!--        </ng-container>-->
<!--      </section>-->
<!--    </ng-container>-->
<!--    <ng-container *ngSwitchDefault>-->
<!--      <img-->
<!--        *ngIf="getImage(i) && getImage(i)['image']"-->
<!--        [src]="getImage(i)['image']['path']"-->
<!--        [style.object-fit]="objectFit"-->
<!--        draggable="false" />-->
<!--    </ng-container>-->
<!--  </ng-container>-->
<!--  <span id="remove-element"  *ngIf="allowDelete" (click)="delete(getImage(i)['image']['path'])">{{ 'GENERAL.REMOVE' | translate }}</span>-->
<!--</div>-->
